<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleClose"
    >
      <div style="padding: 20px">
        <trainingVideo ref="trainingVideo" :sourceUrl="resourcePath"></trainingVideo>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import trainingVideo from "@/components/training/trainingVideo";
export default {
  components:{trainingVideo},
  data() {
    return {
      title:"预览",
      dialogVisible:false,
      resourcePath:"",
    }
  },
  methods: {
    handleClose() {
      this.$refs.trainingVideo.pause();
    },
    show(data){
      this.resourcePath=data;
      this.dialogVisible=true;
    }

  }
}
</script>


<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/definition/previewVideo.vue